/* ============================================================================
   tne-product-hero.js
   • Quantidade +/− com preço dinâmico (qty × preço unitário)
   • Sincroniza id da variante no submit quando troca <select>
   • Stories: clicar num tile abre popup com o vídeo
   • Quick-add "Combina muito com": clique no card adiciona ao carrinho
   ============================================================================ */
(function () {
  'use strict';

  document.querySelectorAll('[data-tne-product-hero]').forEach(initHero);

  function initHero(root) {
    initQuantity(root);
    initVariantSelector(root);
    initStories(root);
    initUpsellQuickAdd(root);
  }

  /* ---- Quantidade + preço dinâmico ------------------------------------- */
  function initQuantity(root) {
    var wrapper = root.querySelector('[data-tne-quantity]');
    if (!wrapper) return;
    var input = wrapper.querySelector('.tne-product-hero__qty-input');
    if (!input) return;

    wrapper.querySelectorAll('[data-tne-qty-action]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = parseInt(input.value, 10) || 1;
        var next = btn.dataset.tneQtyAction === 'increase' ? current + 1 : Math.max(1, current - 1);
        input.value = next;
        refreshPriceDisplay(root);
      });
    });

    input.addEventListener('input', function () {
      refreshPriceDisplay(root);
    });
  }

  function refreshPriceDisplay(root) {
    var priceEl = root.querySelector('[data-tne-price]');
    if (!priceEl) return;
    var input = root.querySelector('.tne-product-hero__qty-input');
    var qty = input ? (Math.max(1, parseInt(input.value, 10) || 1)) : 1;
    var unitPrice = parseInt(priceEl.dataset.tneUnitPrice, 10) || 0;
    var current = priceEl.querySelector('.tne-product-hero__price-current');
    if (current) current.textContent = formatPrice(unitPrice * qty);
  }

  /* ---- Variantes ------------------------------------------------------ */
  function initVariantSelector(root) {
    var selects = root.querySelectorAll('[data-tne-variant-option]');
    var dataNode = root.querySelector('[data-tne-variants]');
    var idInput = root.querySelector('[data-tne-variant-id]');
    if (!selects.length || !dataNode || !idInput) return;

    var variants;
    try { variants = JSON.parse(dataNode.textContent); } catch (e) { return; }

    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var values = Array.from(selects).map(function (s) { return s.value; });
        var match = variants.find(function (v) {
          return values.every(function (val, i) { return v.options[i] === val; });
        });
        if (!match) return;
        idInput.value = match.id;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
        updateVariantPrice(root, match);
      });
    });
  }

  function updateVariantPrice(root, variant) {
    var priceEl = root.querySelector('[data-tne-price]');
    var was = root.querySelector('.tne-product-hero__price-was');
    if (priceEl) priceEl.dataset.tneUnitPrice = String(variant.price);
    if (was) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        was.textContent = formatPrice(variant.compare_at_price);
        was.style.display = '';
      } else {
        was.style.display = 'none';
      }
    }
    refreshPriceDisplay(root);
  }

  function formatPrice(cents) {
    var euros = cents / 100;
    var s = euros % 1 === 0 ? euros.toFixed(0) : euros.toFixed(2).replace('.', ',');
    return s + ' €';
  }

  /* ---- Quick-add "Combina muito com" ----------------------------------- */
  function initUpsellQuickAdd(root) {
    var card = root.querySelector('[data-tne-quick-add]');
    if (!card) return;

    card.addEventListener('click', function () {
      if (card.dataset.adding) return;
      var variantId = parseInt(card.dataset.variant, 10);
      if (!variantId) return;

      card.dataset.adding = 'true';
      var idle = card.querySelector('[data-tne-upsell-idle]');
      var done = card.querySelector('[data-tne-upsell-done]');
      if (idle) idle.hidden = true;

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (done) done.hidden = false;
          document.dispatchEvent(new CustomEvent('tne:cart:open', { bubbles: true }));
          setTimeout(function () {
            delete card.dataset.adding;
            if (idle) idle.hidden = false;
            if (done) done.hidden = true;
          }, 2200);
        })
        .catch(function () {
          delete card.dataset.adding;
          if (idle) idle.hidden = false;
        });
    });
  }

  /* ---- Stories (popup vídeo) ----------------------------------------- */
  function initStories(root) {
    var triggers = root.querySelectorAll('[data-tne-story-open]');
    if (!triggers.length) return;
    var modal = root.querySelector('[data-tne-story-modal]');
    var video = modal && modal.querySelector('[data-tne-story-video]');
    if (!modal || !video) return;

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var src = trigger.getAttribute('data-tne-story-src');
        if (!src) return;
        video.setAttribute('src', src);
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        video.currentTime = 0;
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      });
    });

    modal.querySelectorAll('[data-tne-story-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    function closeModal() {
      video.pause();
      video.removeAttribute('src');
      video.load();
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }
})();
